import { BaseEntity } from "yt-ng-framework";

export class EPrijemnicaStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    RedniBroj: number;
    Roba: string;
    Kolicina: number;
    JedinicaMere: string; 
    RobaID: number;
    PristiglaKolicina: number;
    PrimljenaKolicina: number;
    VracenaKolicina: number;

    Deserialize(input:any){
        this.ID=input.ID;
        this.RedniBroj=input.RedniBroj;
        this.Roba=input.Roba;
        this.Kolicina = input.Kolicina;
        this.PristiglaKolicina=input.PristiglaKolicina;
        this.PrimljenaKolicina=input.PrimljenaKolicina;
        this.VracenaKolicina=input.PristiglaKolicina-input.PrimljenaKolicina;
        this.JedinicaMere = input.JedinicaMere;
        this.RobaID=input.RobaID;

        return this;
    }

    Serialize(input:EPrijemnicaStavkaView){
        return input;
    }
}